import dompurify from 'dompurify';

angular.module('shared').factory('MessageService', ["$modal", function($modal) {
  var MessageService, openModal;
  openModal = function(params) {
    return $modal.open({
      template: require('templates/shared/message.html.slim'),
      windowClass: 'message-modal',
      size: params.size,
      resolve: {
        params: function() {
          return params;
        }
      },
      controller: ["$scope", "$modalInstance", "params", function($scope, $modalInstance, params) {
        $scope.title = params.title;
        $scope.message = params.message;
        $scope.bindHtml = params.bindHtml;
        $scope.smallMargins = params.smallMargins;
        $scope.confirmButtonText = params.confirmButtonText || 'Ok';
        $scope.cancelButtonText = params.displayCancelButton ? 'Cancel' : params.cancelButtonText;
        $scope.multiParagraphMessage = Array.isArray(params.message);
        $scope.displayOkButton = !!params.confirmButtonText || params.displayOkButton;
        $scope.ok = function() {
          return $modalInstance.close();
        };
        $scope.purify = function(message) {
          return dompurify.sanitize(message);
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  MessageService = {
    message: function(params) {
      return openModal(params).result;
    },
    messageWithHandle: function(params) {
      var modalInstance;
      modalInstance = openModal(params);
      return {
        result: modalInstance.result,
        dismiss: function() {
          return modalInstance.dismiss('cancel');
        }
      };
    }
  };
  return MessageService;
}]);
